
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const unitTypeApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getUnitTypes: build.query<any, void>({
      query: () => ({
        url: appEndpoint.unitTypes,
        method: 'get',
      }),
      providesTags: ['UnitTypes'],
    }),   
    
  deleteUnitType: build.mutation<void, string>({
        query: (id) => ({
          url: `${appEndpoint.unitTypes}/${id}`,
          method: 'delete',
        }),
        invalidatesTags: ['UnitTypes'],
  }),
  
  addUnitType: build.mutation<any, CommandRequest>({
    query: (data) => ({
      url: appEndpoint.unitTypes,
      method: 'post',
      data: data.body
    }),
    invalidatesTags: (result) => (result ? ["UnitTypes"] : []),
  }),

  updateUnitType: build.mutation<any, CommandRequest>({
    query: (data) => ({
      url: `${appEndpoint.unitTypes}/${data.id}?_method=put`,
      method: 'post',
      data: data.body
    }),
    invalidatesTags: (result) => (result ? ["UnitTypes"] : []),
  }),
  
  }),
  overrideExisting: false,
});

export const {
  useGetUnitTypesQuery,
  useAddUnitTypeMutation,
  useUpdateUnitTypeMutation,
  useDeleteUnitTypeMutation
} = unitTypeApi;